/* mainConditionMapper.ts */

/* Constants */
import { MainConditionType } from "src/shared/constants/main-condition/MainCondition";

export const MAIN_CONDITION_MAPPER: Record<string, string> =
  {
    "": MainConditionType.OTHER,
    c83_3: MainConditionType.C83_3,
    c91_1: MainConditionType.C91_1,
  };
